import {screenFiller} from './screen-filler'

jQuery(document).ready(function($) {
	let current_size = $(window).width()
	let current_screen = ''
	/*
    1 => Desktop view
  	2 => Tablet view
  	3 => Mobile view
  */
	if (current_size > 1023)
		current_screen = 1
	else if (current_size > 767 && current_size < 1024)
		current_screen = 2
	else
		current_screen = 3

	let screenChange = () => {
		let new_size = $(window).width()
		let new_screen = ''
		if (new_size > 1023)
			new_screen = 1
		else if (new_size > 767 && new_size < 1024)
			new_screen = 2
		else
			new_screen = 3

		if (new_screen == current_screen)
			return false
		else {
			current_screen = new_screen
			current_size = new_size
			return true
		}
	}

	$(window).resize(function() {
		if (screenChange())
			screenFiller()
	})
})
